import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { ContactComponent } from './components/contact/contact.component';
import { DiscoverComponent } from './components/discover/discover.component';
import { FooterComponent } from './components/footer/footer.component';
import { FunFactBannerComponent } from './components/fun-fact-banner/fun-fact-banner.component';
import { KenBurnsBannerComponent } from './components/ken-burns-banner/ken-burns-banner.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { QuoteComponent } from './components/quote/quote.component';
import { ReportsComponent } from './components/reports/reports.component';
import { ServicesComponent } from './components/services/services.component';
import { WhoAreWeComponent } from './components/who-are-we/who-are-we.component';

@NgModule({
  declarations: [
    AppComponent,
    KenBurnsBannerComponent,
    ContactComponent,
    ServicesComponent,
    NavBarComponent,
    WhoAreWeComponent,
    FunFactBannerComponent,
    QuoteComponent,
    ReportsComponent,
    PricingComponent,
    FooterComponent,
    DiscoverComponent,
  ],
  imports: [BrowserModule, BrowserAnimationsModule, MatIconModule, ReactiveFormsModule, MatSnackBarModule, HttpClientModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
